
export const ComingSoon = () => {
  return (
    <>
          <div className="flex h-full  w-full justify-center items-center h4">
             Coming Soon
          </div>
    </>
  );
};
